import { ca } from '@cian/analytics';
import { getAnalyticsTabName } from './getAnalyticsTabName';

export function trackTabChange(tab: string) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Infrastructure',
    label: getAnalyticsTabName(tab),
    name: 'oldevent',
    useLastProducts: true,
  });
}
